var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicketIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.419853 8.01078L2.0994 0.735851C2.19323 0.329452 2.59874 0.0760599 3.00514 0.169885L3.38439 0.257443C3.76798 0.346 4.00714 0.728746 3.91859 1.11233C3.83003 1.49591 4.0692 1.87866 4.45278 1.96722L4.87335 2.06431C5.25693 2.15287 5.63968 1.9137 5.72824 1.53012C5.81679 1.14654 6.19954 0.90737 6.58312 0.995927L6.96238 1.08349C7.36878 1.17731 7.62217 1.58282 7.52835 1.98922L5.8488 9.26415C5.75497 9.67055 5.34946 9.92394 4.94306 9.83012L4.5638 9.74256C4.18022 9.654 3.94105 9.27125 4.02961 8.88767C4.11817 8.50408 3.879 8.12134 3.49542 8.03278L3.07485 7.93569C2.69127 7.84713 2.30852 8.08629 2.21996 8.46988C2.13141 8.85346 1.74866 9.09263 1.36508 9.00407L0.985819 8.91651C0.57942 8.82269 0.326028 8.41718 0.419853 8.01078Z",
    fill: "url(#paint0_linear_4235_2396)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4235_2396",
    x1: 4.98376,
    y1: 0.626685,
    x2: 2.96444,
    y2: 9.37331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67C1B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketIcon);
export default __webpack_public_path__ + "static/media/TicketIcon.51deef181e9a607f7fa4ebecf337dea7.svg";
export { ForwardRef as ReactComponent };